(() => {
  const setUnit = (root, metric) => {
    root.dataset.apparelUnit = metric ? 'metric' : 'imperial';
    root.querySelectorAll('[data-apparel-measurement]').forEach((value) => {
      value.textContent = metric ? value.dataset.metric : value.dataset.imperial;
    });
    root.querySelectorAll('[data-apparel-unit-label]').forEach((label) => {
      label.textContent = metric ? '(cm)' : '(in)';
    });
    const button = root.querySelector('[data-apparel-unit-toggle]');
    if (button) {
      button.setAttribute('aria-pressed', String(metric));
      button.textContent = metric ? button.dataset.metricLabel : button.dataset.imperialLabel;
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-apparel-unit-toggle]');
    if (!button) return;
    const root = button.closest('.tcs-apparel-chart, .tcs-apparel-guide');
    if (root) setUnit(root, root.dataset.apparelUnit !== 'metric');
  });
})();
